import { OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RacesService } from '../../../services/races.service';
import { EventsService } from '../../../services/events.service';
import { EnquiryComponent } from '../../modals/enquiry/enquiry.component';
import { CommentComponent } from '../../modals/comment/comment.component';
import { GoingHistoryComponent } from '../../modals/going-history/going-history.component';
var RaceInfoComponent = /** @class */ (function () {
    function RaceInfoComponent(modalService, notification, racesService, eventsService) {
        var _this = this;
        this.modalService = modalService;
        this.notification = notification;
        this.racesService = racesService;
        this.eventsService = eventsService;
        this.getRaceInfo = function (race) {
            _this.meta.raceInfo.loading = true;
            _this.racesService.getRaceInfo(_this.selectedRace).subscribe(function (res) {
                _this.selectedRace.info = res;
                if (_this.selectedRace.info.ratingBandLowest === -1) {
                    _this.selectedRace.info.ratings = null;
                }
                else {
                    _this.selectedRace.info.ratings = _this.selectedRace.info.ratingBandLowest + " - " + _this.selectedRace.info.ratingBandHighest;
                }
                if (_this.selectedRace.info.prizes) {
                    _this.selectedRace.info.prizes = _this.selectedRace.info.prizes.filter(function (p) { return p !== '0.00'; });
                }
                _this.selectedRace.info.tvCoverage = _this.selectedRace.info.tvCoverage.replace(/_/g, ' ');
                _this.selectedRace.info.jumpType = _this.selectedRace.info.jumpType.replace(/_/g, ' ');
                // console.log('Race Info:', this.selectedRace.info);
                _this.meta.raceInfo.loading = false;
            }, function (err) {
                _this.notification.error("Could't get the " +
                    (moment(_this.selectedRace.raceDatetime).format('HH:mm') + " race's info: " + _this.eventsService.getApiErrorMessage(err)), 'Error!');
                _this.meta.raceInfo.loading = false;
            });
        };
        this.getRaceComments = function (race) {
            _this.meta.raceComments.loading = true;
            _this.racesService.getRaceComments(_this.selectedRace).subscribe(function (res) {
                _this.selectedRace.comments = res.data;
                // console.log('Race Comments:', this.selectedRace.comments);
                _this.meta.raceComments.loading = false;
            }, function (err) {
                _this.notification.error("Could't get the " +
                    (moment(_this.selectedRace.raceDatetime).format('HH:mm') + " race's comments: ") +
                    ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!');
                _this.meta.raceComments.loading = false;
            });
        };
        this.updateRaceComments = function (payload) {
            if (payload.section === 'raceComments') {
                console.log('race comments changed', payload);
                var commentIndex = _this.selectedRace.comments.findIndex(function (e) { return e.id === Number(payload.result.id); });
                if (commentIndex !== -1) {
                    if (payload.result.deleted) {
                        _this.selectedRace.comments.splice(commentIndex, 1);
                    }
                    else {
                        _this.selectedRace.comments[commentIndex] = payload.result;
                    }
                }
                else {
                    _this.selectedRace.comments.unshift(payload.result);
                }
            }
        };
        this.getHorsesComments = function (race) {
            _this.meta.horsesComments.loading = true;
            _this.selectedRace.horsesComments = [];
            _this.meta.horsesComments.loading = false;
            // this.racesService.getRaceComments(this.selectedRace).subscribe(
            //   res => {
            //     this.selectedRace.comments = res.data;
            //     // console.log('Race Comments:', this.selectedRace.comments);
            //     this.meta.horsesComments.loading = false;
            //   },
            //   err => {
            //
            //     this.notification.error(`Could't get the ` +
            //     `${moment(this.selectedRace.raceDatetime).format('HH:mm')} race's comments: ` +
            //     `${this.eventsService.getApiErrorMessage(err)}`, 'Error!');
            //     this.meta.horsesComments.loading = false;
            //   }
            // );
        };
        this.updateHorseComments = function (payload) {
            if (payload.section === 'horseComments') {
                // if (payload.result.rpcComments) {
                // console.log('horses comments changed', payload);
                var commentIndex = _this.selectedRace.horsesComments.findIndex(function (e) { return e.id === Number(payload.result.id); });
                if (commentIndex !== -1) {
                    if (payload.result.deleted) {
                        _this.selectedRace.horsesComments.splice(commentIndex, 1);
                    }
                    else {
                        _this.selectedRace.horsesComments[commentIndex] = payload.result;
                    }
                }
                else {
                    _this.selectedRace.horsesComments.unshift(payload.result);
                }
                // }
            }
        };
        this.getRaceEnquiries = function (race) {
            _this.meta.raceEnquiries.loading = true;
            _this.racesService.getRaceEnquiries(_this.selectedRace).subscribe(function (res) {
                _this.selectedRace.enquiries = res.data;
                _this.selectedRace.enquiries.forEach(function (enquiry) {
                    var breachStatus = enquiry.outcomes.find(function (eo) { return eo.objectType === 'inBreach'; });
                    if (breachStatus !== undefined && breachStatus.isApplied) {
                        enquiry.breachStatus = breachStatus.value.replace(/_/g, ' ');
                    }
                    else {
                        enquiry.breachStatus = 'not in breach';
                    }
                });
                // console.log('Race Enquiries:', this.selectedRace.enquiries);
                _this.meta.raceEnquiries.loading = false;
            }, function (err) {
                _this.notification.error("Could't get the " +
                    (moment(_this.selectedRace.raceDatetime).format('HH:mm') + " race's enquiries: ") +
                    ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!');
                _this.meta.raceEnquiries.loading = false;
            });
        };
        this.updateEnquiries = function (payload) {
            if (payload.section === 'enquiries') {
                console.log('enquiries changed', payload);
                var breachStatus = payload.result.outcomes.find(function (eo) { return eo.objectType === 'inBreach'; });
                if (breachStatus !== undefined && breachStatus.isApplied) {
                    payload.result.breachStatus = breachStatus.value.replace(/_/g, ' ');
                }
                else {
                    payload.result.breachStatus = 'not in breach';
                }
                var enquiryIndex = _this.selectedRace.enquiries.findIndex(function (e) { return e.enquiryId === payload.result.enquiryId; });
                if (enquiryIndex !== -1) {
                    if (payload.result.deleted) {
                        _this.selectedRace.enquiries.splice(enquiryIndex, 1);
                    }
                    else {
                        _this.selectedRace.enquiries[enquiryIndex] = payload.result;
                    }
                }
                else {
                    _this.selectedRace.enquiries.unshift(payload.result);
                }
            }
        };
        this.openEnquiry = function (enquiryId) {
            var modalWindow = _this.modalService.open(EnquiryComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.enquiry = { enquiryId: enquiryId };
            modalWindow.result.then(function (result) {
                console.log("[ DEBUG ] Modal Closed with response", result);
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
        this.openComment = function (id) {
            var modalWindow = _this.modalService.open(CommentComponent, { centered: true, backdrop: 'static', size: 'lg' });
            modalWindow.componentInstance.comment = { id: id };
            modalWindow.result.then(function (result) {
                console.log("[ DEBUG ] Modal Closed with response", result);
            }, function (reason) {
                // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            });
        };
    }
    RaceInfoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.meta = {
            loading: false,
            saving: false,
            raceInfo: {
                loading: false,
                saving: false
            },
            raceEnquiries: {
                loading: false,
                saving: false
            },
            horsesComments: {
                loading: false,
                saving: false,
                failed: false,
            },
            raceComments: {
                loading: false,
                saving: false
            },
            fixtureComments: {
                loading: false,
                saving: false
            }
        };
        this.eventsService.observableComments.subscribe(function (payload) {
            // console.log('triggered from comments changes');
            if (payload.section === 'raceComments') {
                _this.updateRaceComments(payload);
            }
            if (payload.section === 'fixtureComments') {
                _this.updateFixtureComments(payload);
            }
            if (payload.section === 'horseComments') {
                _this.updateHorseComments(payload);
            }
        }, function (error) { return console.log(error); }, function () { return console.log('done'); });
        this.eventsService.observableEnquiries.subscribe(function (payload) {
            // console.log('triggered from enquiries changes');
            _this.updateEnquiries(payload);
        }, function (error) { return console.log(error); }, function () { return console.log('done'); });
        this.getRaceInfo(this.selectedRace);
        this.getRaceComments(this.selectedRace);
        this.getRaceEnquiries(this.selectedRace);
        this.getHorsesComments(this.selectedRace);
    };
    RaceInfoComponent.prototype.updateFixtureComments = function (payload) {
        if (payload.section === 'fixtureComments') {
            console.log('fixture comments changed', payload);
            var commentIndex = this.selectedFixture.comments.findIndex(function (e) { return e.id === Number(payload.result.id); });
            if (commentIndex !== -1) {
                if (payload.result.deleted) {
                    this.selectedFixture.comments.splice(commentIndex, 1);
                }
                else {
                    this.selectedFixture.comments[commentIndex] = payload.result;
                }
            }
            else {
                this.selectedFixture.comments.unshift(payload.result);
            }
        }
    };
    RaceInfoComponent.prototype.openGoingHistory = function () {
        var modalWindow = this.modalService.open(GoingHistoryComponent, { centered: true, backdrop: 'static', size: 'lg' });
        modalWindow.componentInstance.fixture = this.selectedFixture;
        modalWindow.result.then(function (result) {
            // console.log(`[ DEBUG ] Modal dismissed: ${result}`);
        }, function (reason) {
            // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
        });
    };
    Object.defineProperty(RaceInfoComponent.prototype, "offTime", {
        get: function () {
            var info = this.selectedRace && this.selectedRace.info;
            if (!info) {
                return null;
            }
            if (info.startTime) {
                var parsed = moment(info.startTime, ['HH:mm:ss.SS', 'HH:mm:ss.SSS', 'HH:mm:ss'], true);
                return parsed.isValid() ? parsed.format('h:mm:ss A') : null;
            }
            if (info.startersStartTime) {
                var parsed = moment(info.startersStartTime);
                return parsed.isValid() ? parsed.format('h:mm:ss A') : null;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaceInfoComponent.prototype, "offTimeIsComputerCaptured", {
        get: function () {
            return !!(this.selectedRace && this.selectedRace.info && this.selectedRace.info.startTime);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RaceInfoComponent.prototype, "showActualRaceTime", {
        /** Hide when Actual Race Time matches Off Time (same displayed clock time). */
        get: function () {
            var info = this.selectedRace && this.selectedRace.info;
            if (!info || !info.actualRaceTime) {
                return false;
            }
            var off = this.offTime;
            if (!off) {
                return true;
            }
            var actual = moment(info.actualRaceTime, ['HH:mm:ss.SS', 'HH:mm:ss.SSS', 'HH:mm:ss'], true);
            if (!actual.isValid()) {
                return true;
            }
            return actual.format('h:mm:ss A') !== off;
        },
        enumerable: true,
        configurable: true
    });
    return RaceInfoComponent;
}());
export { RaceInfoComponent };
